export const columns = [
    {
        title: 'Mã',
        dataIndex: 'code',
        width: 150,
        key: 'code',
    },
    {
        title: 'Lĩnh vực',
        dataIndex: 'fieldName',
        key: 'fieldName',
    },
    {
        title: 'Dự án',
        dataIndex: 'projectName',
        key: 'projectName',
    },
    {
        title: 'Mảng công việc',
        dataIndex: 'workTypeName',
        key: 'workTypeName',
    },
    {
        title: 'Mục tiêu & KR',
        dataIndex: 'purpose',
        key: 'purpose',
    },
    {
        title: 'PIC',
        dataIndex: 'picName',
        key: 'picName',
    },
]

export const versionPlanPeriodYear = [
    { label: 'Phiên bản đầu năm', value: 1 },
    { label: 'Phiên bản điều chỉnh giữa năm', value: 2 },
]